import { PropsWithChildren, useEffect } from "react";
import { toast } from "react-toastify";
import { CleanHtmlFragment } from "@sharedComponents/CleanHtmlFragment";
import authService from "@sharedComponents/api-authorization/AuthorizeService";

export default function HealthCheck(props: PropsWithChildren<any>) {
    function renderHealthCheckMessage() {
        return <CleanHtmlFragment valueOrKey={"HealthCheck.Message"} />;
    }

    function showHealthCheckToast() {
        toast.warn(renderHealthCheckMessage(), {
            position: "top-center",
            autoClose: 7000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            style: { width: "600px" },
        });
    }

    async function handleHealthCheck() {
        // Do nothing if user is not authenticated
        if (!(await authService.isAuthenticated())) {
            return;
        }

        const response = await fetch("/health", {
            headers: {},
        });
        const content = await response.text();

        try {
            if (!response.ok || content.trim() !== "Healthy") {
                showHealthCheckToast();
            }
        } catch (err: any) {
            // Show nothing because user is not authenticated
            if (err.status === 401 || err.status === 403) {
                return;
            }

            console.error(err);
            showHealthCheckToast();
        }
    }

    useEffect(() => {
        handleHealthCheck();
    }, []);

    // Component is not blocking: does not wait for health check request to
    // complete
    return props.children;
}
